import ITEM from 'utils/constants/items'
import roundCredits from 'utils/roundCredits'

export default function enhancer(input) {
    const { data = {} } = input
    return {
        ...input,
        data: {
            ...data,
            [ITEM.PRE_SEASON_ENGINE]: {
                ...data[ITEM.PRE_SEASON_ENGINE],
                options: data[ITEM.PRE_SEASON_ENGINE].options.map(option => ({
                    ...option,
                    prices: option.prices.map(roundCredits)
                }))
            },
            [ITEM.PRE_SEASON_GEARBOX]: {
                ...data[ITEM.PRE_SEASON_GEARBOX],
                options: data[ITEM.PRE_SEASON_GEARBOX].options.map(option => ({
                    ...option,
                    prices: option.prices.map(roundCredits)
                }))
            },
            [ITEM.PRE_SEASON_WHEELS]: {
                ...data[ITEM.PRE_SEASON_WHEELS],
                options: data[ITEM.PRE_SEASON_WHEELS].options.map(option => ({
                    ...option,
                    prices: option.prices.map(roundCredits)
                }))
            },
        }
    }
}



// WEBPACK FOOTER //
// src/utils/dataEnhancer/phases/preSeason.js